import { apiClient } from "./client";

export const anywareAPI = {
  putEntitlement(userName, hostName) {
    return apiClient.put("/anyware/entitlement", { userName, hostName });
  },

  deleteEntitlement(userName, hostName) {
    return apiClient.delete("/anyware/entitlement", {
      data: { userName, hostName },
    });
  },
};
